import { formatDate } from 'utils/formHelper';

const formatSalary = ({ valid_from, currency, sum }) => ({
  valid_from: formatDate(valid_from),
  [currency]: sum,
});

export { formatSalary };
